<div class="sp-width__full sp-grid__summary-8 sp-grid__gap sp-overflow__x-scroll">
    <app-shared-summary-item
            [item_label]="'UNPAID.TOTAL_LABEL'"
            [item_value]="summary?.total?.toString() || '0'"
            [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
    <app-shared-summary-item
            [item_label]="'UNPAID.TO_RECOVER_LABEL'"
            [item_value]="summary?.to_recover?.toString() || '0'"
            [item_class]="'sp-orders__status-canceled'"
            [label_class]="'sp-color__contrast'"
            [value_class]="'sp-color__contrast'"
            [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
    <app-shared-summary-item
            [item_label]="'UNPAID.0_5_LABEL'"
            [item_value]="summary?.unpaid_0_5?.toString() || '0'"
            [item_class]="'sp-orders__status-pending'"
            [label_class]="'sp-color__primary'"
            [value_class]="'sp-color__primary'"
            [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
    <app-shared-summary-item
            [item_label]="'UNPAID.5_10_LABEL'"
            [item_value]="summary?.unpaid_5_10?.toString() || '0'"
            [item_class]="'sp-orders__status-pending'"
            [label_class]="'sp-color__primary'"
            [value_class]="'sp-color__primary'"
            [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
    <app-shared-summary-item
            [item_label]="'UNPAID.10_15_LABEL'"
            [item_value]="summary?.unpaid_10_15?.toString() || '0'"
            [item_class]="'sp-orders__status-pending'"
            [label_class]="'sp-color__primary'"
            [value_class]="'sp-color__primary'"
            [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
    <app-shared-summary-item
            [item_label]="'UNPAID.15_20_LABEL'"
            [item_value]="summary?.unpaid_15_20?.toString() || '0'"
            [item_class]="'sp-orders__status-pending'"
            [label_class]="'sp-color__primary'"
            [value_class]="'sp-color__primary'"
            [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
    <app-shared-summary-item
            [item_label]="'UNPAID.20_25_LABEL'"
            [item_value]="summary?.unpaid_20_25?.toString() || '0'"
            [item_class]="'sp-orders__status-pending'"
            [label_class]="'sp-color__primary'"
            [value_class]="'sp-color__primary'"
            [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
    <app-shared-summary-item
            [item_label]="'UNPAID.25_30_LABEL'"
            [item_value]="summary?.unpaid_25_30?.toString() || '0'"
            [item_class]="'sp-orders__status-pending'"
            [label_class]="'sp-color__primary'"
            [value_class]="'sp-color__primary'"
            [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
</div>
